export const DEFAULT_EMPLOYEE_RANGES = [
  { label: "10,000 and above", min: 10_000, max: null },
  { label: "5,000 to 9,999", min: 5000, max: 9999 },
  { label: "1,000 to 4,999", min: 1000, max: 4999 },
  { label: "500 to 999", min: 500, max: 999 },
  { label: "200 to 499", min: 200, max: 499 },
  { label: "50 to 199", min: 50, max: 199 },
  { label: "1 to 49", min: 1, max: 49 },
];
